
import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('navigation', () => {
  const homeScrollY = ref(null);
  const homeQuery = ref(null);
  const returningToHome = ref(false);
  const navigationCount = ref(0);

  const canGoBack = computed(() => navigationCount.value > 0);

  function markNavigated() {
    navigationCount.value++;
  }

  function saveScroll(scrollY) {
    homeScrollY.value = scrollY;
  }

  function saveQuery(query) {
    homeQuery.value = query;
  }

  function setReturningToHome(val) {
    returningToHome.value = val;
  }

  function consumeScrollY() {
    const val = homeScrollY.value;
    homeScrollY.value = null;
    return val;
  }

  function consumeQuery() {
    const val = homeQuery.value;
    homeQuery.value = null;
    return val;
  }

  function resetAll() {
    homeScrollY.value = null;
    homeQuery.value = null;
    returningToHome.value = false;
  }

  return {
    homeScrollY,
    homeQuery,
    returningToHome,
    navigationCount,
    canGoBack,
    markNavigated,
    saveScroll,
    saveQuery,
    setReturningToHome,
    consumeScrollY,
    consumeQuery,
    resetAll,
  };
});
